import { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DISPENSER_LINK, ALGO_NETWORK } from "../../../constants/constants";
import { ReactComponent as TW } from "../../../assets/images/tradingview-logo.svg";
import styleHeader from "./Header.module.scss";
import { ConnectWallet } from "./ConnectWallet/ConnectWallet";
import { ReactComponent as Faucet } from "../../../assets/images/faucet-water.svg";
import { ReactComponent as Tutorial } from "../../../assets/images/tutorial.svg";
import { ReactComponent as Vip } from "../../../assets/images/vip_img.svg";
import { ReactComponent as Aff } from "../../../assets/images/icon_affiliates.svg";
import { ReactComponent as Pool } from "../../../assets/images/pool.svg";
import { ReactComponent as Swap } from "../../../assets/images/swap.svg";
import { ReactComponent as Trade } from "../../../assets/images/trade.svg";
import { ReactComponent as Account } from "../../../assets/images/wallet_account.svg";
import { ReactComponent as LINK } from '../../../assets/images/aff_link.svg';
import Feedback from "../Feedback/Feedback";
import RequestVoting from "../RequestVoting/RequestVoting";
import { NavLink, useLocation } from "react-router-dom";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import classNames from "classnames";
import { LogIn } from "./LogIn/LogIn";
import Settings from "../Settings/Settings";
import { FooterTimer } from "../Footer/FooterTimer";
import { AffDashboardVisibilitySettingEnum, POINTS_SETTING } from "../../../interfaces";
import { equalsIgnoreCase } from "../../../_utils";
import { useUltradeWallet } from "../../../wallets/useUltradeWallet";
import { Notifications } from "../Notifications/Notifications";
import { PendingElement } from "./PendingElement/PendingElement";
import { useSocket } from "../../../hooks/useSocket";
import { saveAffiliateParams } from "../../../redux/_actions/user.action";
import { getAppUrl } from "../../../services/localStorage.service";
import { parentAppService } from "../../../App";

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLogged = useIsLoggedSelector();
  const { getKYCStatus } = useUltradeWallet();
  const location = useLocation();
  // const { connectSocket } = useSocket();
  const embeddedAppUrl = getAppUrl();

  const affiliateSetting = useAppSelector((state) => state?.settings.affiliateDashboardVisibility);
  const isAffiliateVisible = useAppSelector((state) => state?.user.isAffiliatePageEnabled);
  const selectedWalletAddress = useAppSelector((state) => state?.user?.activeAddress);
  const mainAddress = useAppSelector((state) => state?.user?.mainAddress);
  const sdkClient = useAppSelector((state) => state?.sdkClient.instance);
  const settings = useAppSelector((state) => state.settings);
  const [expanded, setExpanded] = useState(false);

  const setActive = ({ isActive }) => isActive ? `${styleHeader.link} ${styleHeader.link_active}` : styleHeader.link
  const setActiveSecond = (isActive: boolean) => isActive ? `${styleHeader.link} ${styleHeader.link_active}` : styleHeader.link
  const generateLink = (path: string) => parentAppService.checkIfAppEmbedded() ? embeddedAppUrl : `${embeddedAppUrl}${path}`;

  useEffect(() => {
    if (!sdkClient.companyId || !isLogged) return;
    getKYCStatus();
  }, [isLogged, sdkClient]);

  useEffect(() => {
    if (!equalsIgnoreCase(affiliateSetting, AffDashboardVisibilitySettingEnum.DISABLED)) {
      if (!sdkClient.companyId || !isLogged) return;
      sdkClient.getAffiliatesStatus(settings.companyId)
        .then((r: {enabled: boolean, isAffiliate: boolean}) => {
          const isForAffiliates = equalsIgnoreCase(affiliateSetting, AffDashboardVisibilitySettingEnum.ENABLED_FOR_AFFILIATES);
          dispatch(saveAffiliateParams(r, isForAffiliates));
        })
        .catch(e => console.log(e))
    }
  }, [isLogged, sdkClient, affiliateSetting]);

  // useEffect(() => {
  //   // connectSocket(location.pathname);
  // }, [location.pathname]);

  return (
    <>
      <div className={styleHeader.header}>
        <ErrorBoundary>
        <Navbar 
          expand="lg" 
          expanded={expanded} 
          className={`${styleHeader['navbar']} ${styleHeader['navbar-light']}`}
        >
          <Navbar.Brand 
            href={settings.target}
            target={settings.newTab ? "blank" : "_top"}
            className={classNames(styleHeader['navbar-brand'], {[styleHeader.pointer]: settings.target})}
          >
            { settings[settings.currentTheme].logo && <img src={settings[settings.currentTheme].logo} alt="" className={styleHeader.logo_img}/> }
          </Navbar.Brand>
          <Navbar.Toggle className={styleHeader['navbar-toggler']} aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)}>
            <p className={classNames(styleHeader.hamburger_menu, {[styleHeader.animate]: expanded})} />	
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav" className={styleHeader.amm_nav}>
            <Nav className={styleHeader['navbar-nav']} onClick={() => setExpanded(false)}>
              <NavLink data-testid="account_link" title="Account" className={setActive} to='/account' end>
              {({ isActive }) => (
                <a href={generateLink('/account')} className={setActiveSecond(isActive)}>
                  <Account />
                  {`${t("header.account_text")}`}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </a>
              )}
              </NavLink>
              {settings.obdex && 
                <NavLink data-testid="trade_link" title="Trade" className={setActive} to='/' end>
                {({ isActive }) => (
                  <a href={generateLink('/')} className={setActiveSecond(isActive)}>
                    <Trade />
                    {`${t("header.trade_text")}`}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                )}
                </NavLink>
              }
              {false &&
                <>
                  <NavLink title="Swap" className={setActive} to='/amm/swap'>
                    <Swap />
                    {`${t("comman_word.swap")}`}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </NavLink>
                  <NavLink title="Pools" className={setActive} to='/amm/pools'>
                    <Pool />
                    {`${t("comman_word.pools")}`}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </NavLink> 
                </>}
              {ALGO_NETWORK !== 'MainNet' &&
                <Nav.Link
                  title="Testnet Token Faucet"
                  className={styleHeader.link}
                  href={DISPENSER_LINK}
                  target="_blank"
                > 
                  <Faucet />
                  {t("comman_word.faucet")}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </Nav.Link>
              }
              {settings.isUltrade && 
                <a href="https://www.loom.com/share/a2e7899be50a4e959e024baf0a49d9fd" target="_blank" rel="noreferrer" className={styleHeader.link}>
                  <Tutorial />
                  {t("header.tutorial_text")}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </a>
              }
              { !equalsIgnoreCase(settings.pointSystem, POINTS_SETTING.OFF) && 
                <NavLink title="Points" className={setActive} to='/points'>
                {({ isActive }) => (
                  <a href={generateLink('/points')} className={setActiveSecond(isActive)}>
                    <Vip />
                    {`${t("vip_dashboard.points_text")}`}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                )}
                </NavLink>
              }
              { (equalsIgnoreCase(affiliateSetting, AffDashboardVisibilitySettingEnum.ENABLED_FOR_ALL) || isAffiliateVisible) &&
                <NavLink title="Affiliate" className={setActive} to='/affiliate'>
                {({ isActive }) => (
                  <a href={generateLink('/affiliate')} className={setActiveSecond(isActive)}>
                    <Aff />
                    {`${t("affiliates.affiliate_txt")}`}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                )}
                </NavLink>
              }
              { !!settings.customMenuItems.length && settings.customMenuItems.map((e, ind) => (
                <Nav.Link
                  key={ind}
                  title={e.label}
                  className={styleHeader.link}
                  href={e.url}
                  target="_blank"
                > 
                  <LINK />
                  {e.label}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </Nav.Link>
              ))}
              {settings.reportButtons && 
                <div className={styleHeader.mobile_header}>
                  <Feedback onClick={() => setExpanded(false)} />
                  <RequestVoting />
                </div>
              }
            </Nav>
            <div className={styleHeader.user_settings}>
              <div className={styleHeader.button_cont}>
                <ErrorBoundary>
                  <ConnectWallet />
                </ErrorBoundary>
              </div>
              {((selectedWalletAddress !== mainAddress && isLogged) || (selectedWalletAddress && !isLogged)) && <LogIn/>}
              {ALGO_NETWORK === 'MainNet' && 
                <span>{t("header.mainnet_beta_txt")}</span>
              }
            </div>
            <div className={styleHeader.mobile_view}>
              <p className={classNames(styleHeader.tw_cont ,"tw_cont")}> 
                {t("tradeChart.charts_by")} <TW />
              </p>
              <p>
                {t("tradeChart.provided_by_txt")}
                <a href="https://www.tradingview.com/markets/cryptocurrencies/global-charts/" target="blank" className="link">
                  {t("tradeChart.crypto_market_cap")}
                </a>
                {t("tradeChart.provided_by_txt_2")}
              </p>
              <span className={styleHeader.mobile_view_footer}>
                <FooterTimer showData={false} />
              </span>
            </div>
          </Navbar.Collapse>
        </Navbar>
        <div className={styleHeader.header_items}>
          <PendingElement />
          { isLogged && <Notifications /> }
          <Settings />
        </div>
        </ErrorBoundary>
      </div>
    </>
  );
};

export { Header };
